import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingStatus } from '../../redux/types';
import { initSignupFlow } from '../../redux/auth/authThunk';
import {
  initLanguages,
  setInitialLanguage,
} from '../../redux/localization/localizationThunk';
import { getRegistrationLoadingError } from '../../redux/common/commonSelectors';
import { getLoadingStatus } from '../../redux/auth/authSelectors';
import { DriverSignupMinimal } from './DriverSignupMinimal';
import { autosaveFailed } from '../../redux/autosave/autosaveActions';
import { getTranslations } from '../../redux/form/formSelectors';
import { useTheme } from '../../hooks/useTheme';
import { FullScreenLoader } from '../common/FullScreenLoader';

export const DriverSignupMinimalLayout: React.FC = () => {
  useTheme();
  const dispatch = useDispatch();
  const t = useSelector(getTranslations);
  const loadingStatus = useSelector(getLoadingStatus);
  const loadingErrorMessage =
    useSelector(getRegistrationLoadingError) ??
    t.common_errors.failed_to_load_registration;
  React.useEffect(() => {
    dispatch(autosaveFailed());
    dispatch(setInitialLanguage());
    dispatch(initSignupFlow());
  }, [dispatch]);

  React.useEffect(() => {
    if (loadingStatus === LoadingStatus.FAILED) {
      dispatch(initLanguages());
    }
  }, [dispatch, loadingStatus]);

  return (
    <div id="driver-signup-minimal">
      {loadingStatus === LoadingStatus.READY && <DriverSignupMinimal />}
      {loadingStatus === LoadingStatus.LOADING && (
        <div className="flex items-center justify-center h-screen -mt-6">
          <FullScreenLoader
            data-test="app_form_loader"
            textColor="text-[#E5E7EB] dark:text-[#424B5D]"
            id="minimal-form-loader"
          />
        </div>
      )}
      {loadingStatus === LoadingStatus.FAILED && (
        <div>
          <div className="ml-2 mt-4 font-semibold text-2xl">
            {t.common_errors.unknown_error}
          </div>
          <div className="ml-2 mt-4 text-gray-700 dark:text-gray-300">
            {loadingErrorMessage} <br />
            {t.common_errors.something_went_wrong}
          </div>
        </div>
      )}
    </div>
  );
};
